'use client';

import { Container } from '@aurora-components';
import { FragmentType } from '@gql';
import { ContentPostFragment } from 'lib/shared/content-posts-gql';

import { ContentPost } from 'components/aurora/content-post/content-post';

type Content = FragmentType<typeof ContentPostFragment>;
export function PageContainer({ post, locale }: { post: Content; locale: string }) {
  return (
    <Container
      $paddingTop={8}
      $paddingX={5}
      $maxWidth
      $fullHeight
      $centered
    >
      <ContentPost
        content={post}
        locale={locale}
      />
    </Container>
  );
}
